import { render, staticRenderFns } from "./OutputDissemination.vue?vue&type=template&id=f448cbf4"
import script from "./OutputDissemination.vue?vue&type=script&lang=js"
export * from "./OutputDissemination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports